export const utc_minutes_offset = new Date().getTimezoneOffset();
